import { types } from '../types/types';

type AuthState = Record<string, unknown>;
type AuthAction = {
	type: string;
	payload?: { data?: Record<string, unknown>[]; user?: string };
};

export const userReducer = (
	state: AuthState = {},
	action: AuthAction = { type: '' },
) => {
	switch (action.type) {
		case types.login: {
			const { data, user } = action.payload ?? {};
			const d: Record<string, unknown> = data?.[0] ?? {};

			const ejercicio = d.IdEjercicio
				? {
						IdEjercicio: d.IdEjercicio,
						Etapa: d.Etapa,
						Mes: d.Mes,
						Anio: d.Anio,
						NombreEtapa: d.NombreEtapa,
						MesSiguiente: d.MesSiguiente,
						MesAnterior: d.MesAnterior,
						DiasUtiles: d.DiasUtiles,
						NumeroMes: d.NumeroMes,
					}
				: null;

			return {
				ejercicio,
				etapa: d.Etapa ?? null,
				user,
				grupos: d.grupos ?? null,
				userProviders: d.IdProveedor ? String(d.IdProveedor).split(',') : [],
				initialUrl: d.UrlInicial ?? null,
				urls: d.Urls ?? null,
				menues: d.Menues ?? null,
				reportsId: d.ReportsId ?? 'El ejercicio ha culminado',
				ejCerradoMensaje: d.EjCerradoMensaje ?? '',
				grupoLabel: d.GruposLabel ?? '',
				pqaprobador: d.PQAprobador ?? '',
				nombreUsuario: d.NombreUsuario ?? user,
			};
		}
		case types.logout:
			return {};
		default:
			return state;
	}
};
